import { Outlet } from "react-router-dom"



export default function DemyDahOut() {
  return (
    <div className="blogDashboard" style={{width:"100%"}}>
   {/* <h1>Dashbord Demy Out</h1> */}
    <Outlet/>
        
    </div>
  )
}
